export var MAIN_PANEL_MIN_HEIGHT = 250;
export function getSplitPanelDefaultSize(position) {
    if (typeof document === 'undefined') {
        return 0;
    }
    return position === 'side' ? document.documentElement.clientWidth / 3 : document.documentElement.clientHeight / 2;
}
export function getLimitedValue(min, value, max) {
    if (min > max) {
        return min;
    }
    if (value < min) {
        return min;
    }
    if (value > max) {
        return max;
    }
    return value;
}
